<template>
  <div class="d-flex gc-4">
    <a :href="doctorPageUrl">
      <v-img
        class="rounded-sm"
        :alt="t('Аватар', options)"
        lazy-src="/static/_v1/pd/icons/ui-kit/photo/no-avatar.svg"
        :src="getDoctorAvatarUrl({ doctor })"
        width="100"
        height="100"
      />
    </a>
    <div class="d-flex flex-column justify-center">
      <a
        :href="doctorPageUrl"
        class="text-subtitle-1 text-decoration-none primary--text mb-1"
      >
        {{ transDynamic(doctor, `fio,${languageIso},${needTranslate}`) }}
      </a>
      <RatingRow
        v-if="context.request.feature_flags?.ff_redesign_rating && doctor.stars"
        class="mb-2"
        :solidity="doctor.stars"
        :reviews-count="doctor.rates ?? 0"
        :reviews-href="`${doctorPageUrl}#otzivi`"
      />
      <StarsRate
        v-else
        class="mb-2"
        :solidity="doctor.stars"
      />
      <span class="text-body-2">
        {{ transDynamic(doctor.town, `name,${languageIso},${needTranslate}`) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'
import useURLStore from 'src/store/useURLStore'
import StarsRate from 'src/components/common/StarsRate/StarsRate.vue'
import RatingRow from 'src/components/common/RatingRow/RatingRow.vue'
import getDoctorAvatarUrl from 'src/utils/getDoctorAvatarUrl'
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import useContextStore from 'src/store/useContextStore'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const needTranslate = context.need_translate
const languageIso = context.current_language?.iso ?? ''

const props = defineProps<{
  doctor: NonNullable<ContextStore['context']['subject']>
}>()

const { reverseFull } = useURLStore()
const doctorPageUrl = computed(() => reverseFull({
  name: 'doctor',
  args: [props.doctor.town.translit, props.doctor.translit],
}))
</script>
